import React, {useEffect, useState} from 'react'
import {useLocation, useNavigate} from 'react-router-dom'
import {useSelector, useDispatch} from 'react-redux'
// import {Link} from 'react-router-dom'
// import {useAuth0} from '@auth0/auth0-react'
// import {DataDogEndSession} from '../../../../dataDogConfig'
// import {
//   selectUserData,
//   selectEffectiveRole,
//   selectEnvConfig,
// } from '../../../../app-store/selector'
// import {getEnvironment} from '../../../../utils/get-environment'
// import {PTAvatarSVG, PTInfoSVG, PTNotificationsSVG} from '../../../../assets'
import {
  HeaderContainer,
  // HamburgerBtn,
  LeftBlock,
  // Breadcrumb,
  // NewProposalBtn,
  // HeaderIconBtn,
  // UserChip,
  // UserName,
  // UserAvatar,
  // UserDropdown,
  // DropdownSection,
  // DropdownRow,
  // DropdownKey,
  // DropdownVal,
  // DropdownDivider,
  // DropdownLogoutBtn,
} from './styled.components'
import {ProposalCreationComponent} from '../proposal-creation'
import {DiscardChangesModal} from '../DiscardChangesModal'
import {selectIsDirty, resetAll} from '../../../../app-store/ProposalSlice'

// function getInitials(user = {}) {
//   const first =
//     user?.given_name?.[0] || user?.nickname?.[0] || user?.name?.[0] || ''
//   const second =
//     user?.family_name?.[0] ||
//     (!user?.given_name &&
//       (user?.nickname?.split(/\s+/).pop()?.[0] ||
//         user?.name?.split(/\s+/).pop()?.[0])) ||
//     ''
//   return (first + second).toUpperCase()
// }

// function SignOutIcon() {
//   return (
//     <svg
//       width="14"
//       height="14"
//       viewBox="0 0 24 24"
//       fill="none"
//       stroke="currentColor"
//       strokeWidth="2"
//     >
//       <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" />
//       <polyline points="16 17 21 12 16 7" />
//       <line x1="21" y1="12" x2="9" y2="12" />
//     </svg>
//   )
// }

function ProposalHeader({onNewProposal, onMenuToggle}) {
  // const navigate = useNavigate()
  const location = useLocation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const isProposalDirty = useSelector(selectIsDirty)
  const [isProposalModalOpen, setIsProposalModalOpen] = useState(false)
  const [showDiscardConfirm, setShowDiscardConfirm] = useState(false)

  // const {user} = useSelector(selectUserData)
  // const userRoles = useSelector(selectEffectiveRole)
  // const envConfig = useSelector(selectEnvConfig)
  // const {logout} = useAuth0()
  // const initials = getInitials(user)

  // const [menuOpen, setMenuOpen] = useState(false)
  // const chipRef = useRef(null)

  // useEffect(() => {
  //   const handler = e => {
  //     if (chipRef.current && !chipRef.current.contains(e.target)) {
  //       setMenuOpen(false)
  //     }
  //   }
  //   document.addEventListener('mousedown', handler)
  //   return () => document.removeEventListener('mousedown', handler)
  // }, [])

  // const handleLogout = () => {
  //   DataDogEndSession()
  //   logout({returnTo: window.location.origin})
  // }
  const handleCreateProposal = () => {
    // The proposal-creation flow resets proposalInfo as soon as its modal
    // opens — confirm first if that would drop unsaved builder changes.
    if (
      location.pathname.startsWith('/proposal-tool/proposal-builder') &&
      isProposalDirty
    ) {
      setShowDiscardConfirm(true)
      return
    }
    setIsProposalModalOpen(true)
  }

  const handleConfirmDiscard = () => {
    setShowDiscardConfirm(false)
    dispatch(resetAll())
    setIsProposalModalOpen(true)
  }

  const handleCancelDiscard = () => {
    setShowDiscardConfirm(false)
  }

  const handleProposalModalOpenState = () => {
    setIsProposalModalOpen(false)
  }

  // The "New Proposal" button now lives in the app shell's AppHeader, which
  // can't reach this component's modal state — it navigates to the current
  // route with `openNewProposal` in location.state instead. Opening goes
  // through handleCreateProposal so the unsaved-builder confirm still applies.
  useEffect(() => {
    if (!location.state?.openNewProposal) return
    handleCreateProposal()
    navigate(location.pathname, {replace: true, state: null})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.key])

  return (
    <HeaderContainer>
      <LeftBlock>
        {/* <HamburgerBtn type="button" onClick={onMenuToggle} title="Menu">
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <line x1="3" y1="6" x2="21" y2="6" />
            <line x1="3" y1="12" x2="21" y2="12" />
            <line x1="3" y1="18" x2="21" y2="18" />
          </svg>
        </HamburgerBtn>
        <Breadcrumb>
          <Link to="/">Home</Link>
          {' / Proposal Dashboard'}
        </Breadcrumb> */}
        {/* "Proposal Tool" title now renders in the app shell's AppHeader. */}
      </LeftBlock>

      {/* <HeaderIconBtn title="Notifications">
          <PTNotificationsSVG />
        </HeaderIconBtn>

        <HeaderIconBtn title="Help & Info">
          <PTInfoSVG />
        </HeaderIconBtn>

        <UserChip ref={chipRef} onClick={() => setMenuOpen(o => !o)}>
          <UserName>{user?.name || 'My Account'}</UserName>
          <UserAvatar>{initials || <PTAvatarSVG />}</UserAvatar>

          {menuOpen && (
            <UserDropdown onClick={e => e.stopPropagation()}>
              <DropdownSection>
                <DropdownRow>
                  <DropdownKey>Email :</DropdownKey>
                  <DropdownVal>{user?.email || '—'}</DropdownVal>
                </DropdownRow>
                <DropdownRow>
                  <DropdownKey>Role :</DropdownKey>
                  <DropdownVal>
                    {(userRoles || []).join(', ') || '—'}
                  </DropdownVal>
                </DropdownRow>
                <DropdownRow>
                  <DropdownKey>Environment :</DropdownKey>
                  <DropdownVal>
                    {getEnvironment(envConfig?.hostname)}
                  </DropdownVal>
                </DropdownRow>
              </DropdownSection>
              <DropdownDivider />
              <DropdownLogoutBtn onClick={handleLogout}>
                <SignOutIcon />
                Sign Out
              </DropdownLogoutBtn>
            </UserDropdown>
          )}
        </UserChip> */}
      <ProposalCreationComponent
        isProposalModalOpen={isProposalModalOpen}
        handleProposalModalOpenState={handleProposalModalOpenState}
      />
      <DiscardChangesModal
        isOpen={showDiscardConfirm}
        onCancel={handleCancelDiscard}
        onConfirm={handleConfirmDiscard}
      />
    </HeaderContainer>
  )
}

export {ProposalHeader}
